export default __webpack_public_path__ + "static/media/creativeAgency.8409bed5.PNG";